import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import OnboardingWizard from '@/pages/OnboardingWizard/OnboardingWizard';
import { useAuth } from '@/store/auth/auth.store';
import { captureVesselCode } from '@/utils/vesselCode';

/**
 * Full-screen onboarding page, mounted outside <Layout/> so it has no app chrome
 * and the Layout gate can't loop into it. Guards itself: unauthed → /auth, already
 * onboarded → /dashboard. The `onboarded` flag only flips on the wizard's final
 * "Go to dashboard" click (which navigates away), so the finish screen stays put.
 *
 * A vessel code share link (`?code=`) is remembered before either redirect: a new account
 * comes back here and the wizard opens on Join your vessel, and an onboarded one is asked on
 * the dashboard (VesselCodePrompt).
 */
export const OnboardingRoute = () => {
  const { search } = useLocation();
  const session = useAuth((s) => s.session);
  const isInitializing = useAuth((s) => s.isInitializing);
  // Once, on arrival: the param stays in the URL after the wizard has spent the code, and the
  // session refresh that ends onboarding re-renders this route on its way to the dashboard.
  useState(() => captureVesselCode(search));
  if (isInitializing) return null;
  if (!session) return <Navigate to="/auth" replace />;
  if (session.onboarded) return <Navigate to="/dashboard" replace />;
  return <OnboardingWizard />;
};
